import groupBy from "lodash/fp/groupBy";
import map from "lodash/fp/map";
import find from "lodash/fp/find";
import assign from "lodash/fp/assign";

class UniversalPageTransform {
  constructor(Lists) {
    "ngInject";

    this.Lists = Lists;
  }

  justify(data) {
    const states = this.Lists.all.states;
    const format = (item) => {
      const state = find((state) => state.name === item._type)(states);
      const extra = {
        _id: item._id,
        _type: item._type,
        state: state.state,
        _score: item._score,
      };
      item = assign(extra, item._source);
      item.name = item.note ? item.name + " - " + item.note : item.name;

      return item;
    };
    const formatted = map(format)(data);
    const groupByType = (item) => item._type;

    return groupBy(groupByType)(formatted);
  }
}

export default UniversalPageTransform;



// WEBPACK FOOTER //
// ./src/pages/universal/universal.transforms.js